<template>
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    :fill="fill"
    :stroke="fill"
  >
    <path
      d="M13.7145 10.6226L20.4161 3H18.8282L13.0066 9.61719L8.36025 3H3L10.0278 13.0073L3 21H4.58786L10.7319 14.0104L15.6398 21H21L13.7145 10.6226ZM10.7409 13.3057C10.7409 13.3057 10.3063 12.698 10.0278 12.3086C7.81442 9.21366 4.36242 4.38192 4.36242 4.38192L8.43314 4.22313L13.0066 10.6226L13.7167 11.6197L19.6609 19.9376L15.5902 20.0963L10.7409 13.3057Z"
    />
  </svg>
</template>

<script setup>
defineOptions({
  name: 'V2IconsTwitter'
})

defineProps({
  fill: {
    type: String,
    default: '#671CC2'
  }
})
</script>
